<template>
  <div class="login-page items-center justify-center">
    <v-card class="mx-auto item-card xs-width-responsive">
      <div class="mb-5" :class="isVKNOWS?'logo-vknows':'logo'">
        <v-img v-if="isNerdOf" src="../../assets/layout/TULA.png"></v-img>
        <v-img v-if="isVKNOWS" src="../../assets/layout/vknows_small.png"></v-img>
        <v-img v-if="isClsedo" src="../../assets/layout/clsedo.jpg"></v-img>
      </div>
      <div class="titile my-10">
        <v-card-title
          primary-title
          class="headline justify-center pa-0 font-weight-bold"
          >เลือกองค์กร</v-card-title
        >
        <p class="text-center">กรุณาเลือกองค์กรที่ท่านต้องการเข้าใช้งาน</p>
      </div>
      <v-list-item
        v-for="company in companies"
        @click="updateSelected(company)"
        :key="company._id"
      >
        <v-list-item-avatar>
          <v-img :src="company.companies[0].logo" />
        </v-list-item-avatar>

        <v-list-item-content v-model="selectedCompany">
          <v-list-item-title
            :style="{ color: company.companies[0].themeColor }"
            >{{ company.companies[0].title }}</v-list-item-title
          >
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon>
            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
  </div>
</template>
<script>
// import {logout } from "@/service/account/login";
import { isNerdOf, isVKNOWS, isClsedo } from "../../helper/domain"
export default {
  name: "select-company",
  data() {
    return {
      companies: JSON.parse(localStorage.getItem("companies")),
      selectedCompany: {},
    };
  },
  computed: {
    isVKNOWS() {
      return isVKNOWS();
    },
    isNerdOf() {
      return isNerdOf();
    },
    isClsedo() {
      return isClsedo();
    },
  },
  //  async beforeMount(){
  //   let status = await logout();
  //     console.log("Logout", status);
  //     await this.$store.commit("clear");
  //     await localStorage.clear();

  // },
  methods: {
    updateSelected(selectedItem) {
      this.selectedCompany = selectedItem;
      localStorage.setItem("company", JSON.stringify(this.selectedCompany));
      this.$router.replace({ path: "enter-password" });
    },
  },
};
</script>
<style scoped>
.rowCard {
  height: 400px;
  margin-top: 20px;
}
.titleCard {
  font-weight: bold;
  margin-top: 10px;
  color: rgb(0, 0, 0);
}
.logo {
  width: 20%;
  margin: 0 auto;
}
.logo-vknows {
  width: 180px;
  margin: 0 auto;
}

.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-card {
  width: 30%;
  min-height: 300px;
}
.xs-width-responsive {
  padding: 36px;
}
@media only screen and (max-width: 768px) {
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    height: 100%;
    align-items: unset;
  }
  .xs-width-responsive {
    padding: 22px;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 60%;
    min-height: 560px;
  }

  .login-page {
    height: 100%;
    align-items: center;
  }
}
</style>